import React, { useState } from "react";
import { api } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";
import { ImagePlus, Trash2, Loader2, ImageOff } from "lucide-react";

const API = process.env.REACT_APP_BACKEND_URL;
export const productImageUrl = (p) => (p?.image ? `${API}/api/public/products/${p.id}/image?v=${encodeURIComponent(p.image.updated_at || "")}` : null);

export const ProductImage = ({ product, className = "", testid }) => {
  const url = productImageUrl(product);
  return url ? (
    <img src={url} alt={product.name} className={`object-cover rounded-md bg-muted ${className}`} data-testid={testid} />
  ) : (
    <div className={`flex items-center justify-center rounded-md bg-muted text-muted-foreground ${className}`} data-testid={testid}><ImageOff className="w-5 h-5" /></div>
  );
};

export const ProductImageUpload = ({ product, onChanged }) => {
  const [busy, setBusy] = useState(false);
  if (!product?.id) return <p className="text-[11px] text-muted-foreground">Save the product first, then upload a sample photo.</p>;

  const upload = async (e) => {
    const f = e.target.files?.[0];
    if (!f) return;
    setBusy(true);
    const fd = new FormData(); fd.append("file", f);
    try {
      const { data } = await api.post(`/products/${product.id}/image`, fd, { headers: { "Content-Type": "multipart/form-data" } });
      toast.success("Photo uploaded"); onChanged(data.image);
    } catch (err) { toast.error(err?.response?.data?.detail || "Upload failed"); }
    finally { setBusy(false); e.target.value = ""; }
  };
  const remove = async () => {
    await api.delete(`/products/${product.id}/image`);
    toast.success("Photo removed"); onChanged(null);
  };

  return (
    <div className="flex items-center gap-3" data-testid="product-image-upload">
      <ProductImage product={product} className="w-20 h-20" testid="product-image-preview" />
      <div className="space-y-1">
        <Label className="text-xs">Sample photo (shown to agents)</Label>
        <div className="flex gap-2">
          <label className="cursor-pointer">
            <input type="file" hidden accept="image/*" onChange={upload} data-testid="product-image-input" />
            <span className="inline-flex items-center h-8 px-3 rounded-md border text-xs hover:bg-muted">{busy ? <Loader2 className="w-3.5 h-3.5 animate-spin" /> : <><ImagePlus className="w-3.5 h-3.5 mr-1" /> {product.image ? "Replace" : "Upload"}</>}</span>
          </label>
          {product.image && <Button type="button" size="sm" variant="ghost" className="h-8 text-rose-600" onClick={remove} data-testid="product-image-remove"><Trash2 className="w-3.5 h-3.5" /></Button>}
        </div>
      </div>
    </div>
  );
};
